module.exports = __webpack_public_path__ + "static/media/desk-2.1358c6c5.jpg";